var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuros(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    fill: "none",
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.3542 51.0001C33.1477 51.0001 42.7083 41.4395 42.7083 29.6459C42.7083 17.8523 33.1477 8.29175 21.3542 8.29175C9.56059 8.29175 0 17.8523 0 29.6459C0 41.4395 9.56059 51.0001 21.3542 51.0001ZM22.5154 28.0855V25.1558H18.8747C19.0099 23.5154 20.3872 22.2214 22.062 22.2214H23.2349C24.8522 22.2214 26.1681 23.5373 26.1681 25.1546H29.0978C29.0978 21.9218 26.4677 19.2917 23.2349 19.2917H22.062C18.7714 19.2917 16.0792 21.8988 15.9399 25.1558H13V28.0855H15.9332V31.0199H13V33.9496H15.9399C16.0791 37.2065 18.7714 39.8136 22.062 39.8136H23.2349C26.4677 39.8136 29.0978 37.1835 29.0978 33.9507H26.1681C26.1681 35.5681 24.8522 36.8839 23.2349 36.8839H22.062C20.3872 36.8839 19.0099 35.5901 18.8747 33.9496H22.5154V31.0199H18.8629V28.0855H22.5154Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M43.303 37.8839C47.4266 33.9906 50.0001 28.4729 50.0001 22.3542C50.0001 10.5606 40.4395 1 28.6459 1C22.5272 1 17.0095 3.57346 13.1162 7.69706C15.6791 6.73469 18.4552 6.20833 21.3543 6.20833C34.2984 6.20833 44.7918 16.7017 44.7918 29.6458C44.7918 32.5449 44.2654 35.321 43.303 37.8839Z",
    clipRule: "evenodd",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuros);
export default __webpack_public_path__ + "static/media/euros.9002085271509d871669b0dc6760ca95.svg";
export { ForwardRef as ReactComponent };